export enum ReasoningType {
    Undefined = 0,
    Selection = 1,
    Correction = 2,
    Archive = 3,
}

const getReasoningTitle = (reasoningType: ReasoningType): string => {
    return ReasoningType[reasoningType] + " Reasoning";
};

const getReasoningGuidelines = (reasoningType: ReasoningType): string => {
    return ReasoningTypeGuidelines.get(reasoningType) || "";
};

const getReasoningPlaceholder = (reasoningType: ReasoningType): string[] => {
    return ReasoningTypePlaceholders.get(reasoningType) || [];
};

const ReasoningTypeGuidelines: Map<ReasoningType, string> = new Map<
    ReasoningType,
    string
>([
    [ReasoningType.Selection, "Explain why you grouped these errors together"],
    [
        ReasoningType.Correction,
        "Explain how you concluded these steps would solve the problem​",
    ],
    [ReasoningType.Archive, "Explain why you decided to archive the error(s)"],
]);

const ReasoningTypePlaceholders: Map<ReasoningType, string[]> = new Map<
    ReasoningType,
    string[]
>([
    [
        ReasoningType.Selection,
        [
            "How did you know these errors are suitable to be corrected together​?",
            "What separates this group from other errors with a similar problem/fix?",
        ],
    ],
    [
        ReasoningType.Correction,
        [
            "What is the scenario? What are the conditions? Try to be as specific as possible.",
            "Were there several steps involved in the process? If so, please describe each step.",
            "How did you determine the new values would be the correct ones?",
            "If you did not change any values, how did you know resubmission would be successful?",
            "If possible, describe the root cause of the error.",
        ],
    ],
    [
        ReasoningType.Archive,
        [
            "Are these errors not correctable? If so, why?",
            "Were these errors handled externally, in another system? If so, how and where?",
        ],
    ],
]);

export interface ReasoningItemConfig {
    reasoningType: ReasoningType;
    title: string;
    guidelines: string;
    placeholder: string[];
}

export const ReasoningItemConfigs = {
    Selection: {
        reasoningType: ReasoningType.Selection,
        title: getReasoningTitle(ReasoningType.Selection),
        guidelines: getReasoningGuidelines(ReasoningType.Selection),
        placeholder: getReasoningPlaceholder(ReasoningType.Selection),
    },
    Correction: {
        reasoningType: ReasoningType.Correction,
        title: getReasoningTitle(ReasoningType.Correction),
        guidelines: getReasoningGuidelines(ReasoningType.Correction),
        placeholder: getReasoningPlaceholder(ReasoningType.Correction),
    },
    Archive: {
        reasoningType: ReasoningType.Archive,
        title: getReasoningTitle(ReasoningType.Archive),
        guidelines: getReasoningGuidelines(ReasoningType.Archive),
        placeholder: getReasoningPlaceholder(ReasoningType.Archive),
    },
    Undefined: {
        reasoningType: ReasoningType.Undefined,
        title: getReasoningTitle(ReasoningType.Undefined),
        guidelines: getReasoningGuidelines(ReasoningType.Undefined),
        placeholder: getReasoningPlaceholder(ReasoningType.Undefined),
    },
} satisfies Record<keyof typeof ReasoningType, ReasoningItemConfig>;
